import SmsText from '../../components/enroll-activation-link-set/SmsText';
import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';

export default class EnrollActivationLinkSentCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;

  async shouldCustomize() {
    return [ 'enroll-activation-link-sent' ].includes(this.context?.controller);
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}EnrollActivationLinkSent::Landing`);
    super.forgifyController();
    this.forgifyPhoneNumberText();
  }

  private forgifyPhoneNumberText() {
    const phoneNumberElement = jQueryCourage('.phone-number');
    if (phoneNumberElement.length) {
      const parentContainer = phoneNumberElement.closest('div');
      const forgeComponent = <SmsText container={parentContainer} />;
      this.renderForgeAndHideOktaComponent({
        id: 'sms-text',
        oktaComponent: parentContainer,
        forgeComponent: forgeComponent,
      });
    }
  }
}
